// External modules
import { useStoreState } from '@/store';

/*
  TODO!:
  This hook checks if some of interstitials are open. I need
  this logic for CTA content key spike work. We reuse SubmitButton
  on some of these interstitials and I do not need to log FPTI
  from interstitals, but only billing page.
  Once, spike work is done and finished. We can clean up
  code and along with other unused code when we take CTA standardize
  JIRA story
*/
export const useInterstitialOpen = (): boolean => {
  const isMemberBenefitsTrueGuestsInterstitialOpen = useStoreState(
    ({ ui }) => ui.isMemberBenefitsTrueGuestsInterstitialOpen,
  );
  const isPhoneConfirmationOpen = useStoreState(
    ({ ui }) => ui.isPhoneConfirmationOpen,
  );
  const isPasswordlessUpgradeOpen = useStoreState(
    ({ ui }) => ui.isPasswordlessUpgradeOpen,
  );

  return Boolean(
    isMemberBenefitsTrueGuestsInterstitialOpen ||
      isPhoneConfirmationOpen ||
      isPasswordlessUpgradeOpen,
  );
};
